import { createUseStyles } from 'react-jss'
import { Colors } from "../../../../constants/colors"
import { Fonts } from '../../../../constants/fonts'
import { formatDateString } from '../../../../util/date'

interface PayrollHeaderProps {
  labelText: string
  paymentDate: string
}

const PayrollHeader = ({ labelText, paymentDate }: PayrollHeaderProps) => {
  const styles = useStyles()

  return (
    <div className={styles.headerContainer}>
      <span className={styles.headerLabel}>
        {labelText}
      </span>
      <span className={styles.paymentDate}>
        {formatDateString(paymentDate)}
      </span>
    </div>
  )
}

const useStyles = createUseStyles({
  headerContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column'
  },
  headerLabel: {
    color: Colors.euro_800,
    fontSize: 13,
    textTransform: 'uppercase'
  },
  paymentDate: {
    fontFamily: Fonts.semiBold,
    fontSize: 20
  }
})

export default PayrollHeader 